import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import BreakingNewsStories from "@pages/Home/BreakingNews/BreakingNewsStories";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import type { SanitizedSectionArticle } from "@typings/Cue";
import { sectionNavigationItems } from "@util/constant";

export type BreakingNewsProps = {
  testId?: string | null;
  rootClassName?: string;
  data?: SanitizedSectionArticle[];
};

const section = sectionNavigationItems["breaking-news"];

export default function BreakingNews({
  testId = null,
  rootClassName,
  data = [],
}: BreakingNewsProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);

  return (
    <section
      className={rootClassName}
      data-testid={testId}
      id="homepage-breakingnews-section"
    >
      <BlockTitle link={section?.link} text={section?.label?.toUpperCase()} />

      <div className="stories lg:grid lg:grid-cols-3 lg:gap-4">
        <div className="lg:col-span-2 lg:grid lg:grid-cols-2">
          {data?.map((article, index: number) =>
            article ? (
              <BreakingNewsStories
                article={article}
                index={index}
                key={index}
                disablePaywall={
                  OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER
                }
              />
            ) : null
          )}
        </div>

        <div className="bg-gray-125 lg:col-start-3 lg:h-auto">
          <div className="sticky top-[40px]">
            <Ad
              adType="imu2"
              className="-mx-3 flex flex-col items-center justify-center border-t border-gray-175 bg-gray-125 py-6 md:mx-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
